export const flujosEditEnabled = process.env.REACT_APP_FLUJOS_EDIT_ENABLED !== 'false';
